<template>
  <div class="wrong-container">
    <p>暂未上线，敬请期待</p>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {}
    }
  }
</script>

<style scoped>
  .wrong-container{
    width:850px;
    background:#fff;
    border-radius: 6px;
    height: 800px;
    position: relative;
    overflow: hidden;
  }
  .wrong-container {
    text-align: center;
    padding-top: 200px;
    font-size: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AccMyStudy/children/wrong.vue